export const HEADER_CONSTANTS = {
  LOGO_TEXT: 'Dimple & Ashwin',
  NAV_LABELS: {
    EVENTS: 'Events',
    PHOTOS: 'Photos',
    FAQ: 'FAQ',
    RSVP: 'RSVP',
    ADMIN: 'Admin',
  },
  ARIA_LABELS: {
    BANNER: 'banner',
    PRIMARY_NAV: 'Primary',
  },
};